import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { Header, PrivacyPermissionsSection } from '../Components';
import PrivacyPermissionsOverlayProps from '../PrivacyPermissionsOverlay.context';
import { PageEnums } from '../PrivacyPermissionsOverlay.Enums';
import styles from '../PrivacyPermissionsOverlay.styles';

class Privacy extends Component {
  static contextType = PrivacyPermissionsOverlayProps;

  render() {
    return (
      <>
        <Header onBackPress={() => this.props.goToPage(PageEnums.INTRO)}>
          <VFText
            style={styles.headerTitle}
            i18nKey={'privacy_permissions_privacy_policy'}
            testKey={FrameworkTestKeys.PPOPrivacyHeaderTitle}
          />
        </Header>

        {this.context.privacyPolicySections?.map((section, index) => (
          <PrivacyPermissionsSection index={index} key={index} section={section} />
        ))}
      </>
    );
  }
}

Privacy.propTypes = {
  goToPage: PropTypes.func.isRequired,
  theme: PropTypes.object,
};

export default withTheme(Privacy);
